export default function(ts: string | number) {
    let timestamp = typeof ts === 'string' ? parseInt(ts, 10) : ts;
    if (isNaN(timestamp)) { return 'Fecha invalida'; }
    const date = new Date(timestamp);
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
}


// WEBPACK FOOTER //
// ./src/utils/timestampToString.ts